export enum PROFILE_BASIC_INFO {
  FIRST_NAME = "clientProfileFirstName",
  LAST_NAME = "clientProfileLastName",
  EMAIL = "clientProfileEmail",
  BIRTH_DATE_PICKER = "clientProfileBirthDatePicker",
  BIRTH_DATE_PICKER_MONTH = "clientProfileBirthDatePickerMonth",
  BIRTH_DATE_PICKER_YEAR = "clientProfileBirthDatePickerYear",
  BIRTH_DATE_PICKER_VALUE = "clientProfileBirthDatePickerValue",
  HOME_PHONE = "clientProfileHomePhone",
  MOBILE_PHONE = "clientProfileMobilePhone",
  SERVICE_VOUCHER = "clientProfileServiceVoucher",

  B2B_COMPANY_EMAIL = "clientProfileB2BCompanyEmail",
  B2B_LOGIN_EMAIL = "clientProfileB2BLoginEmail",
  B2B_COMPANY_NAME = "clientProfileB2BCompanyName",
  B2B_COMPANY_PHONE = "clientProfileB2BCompanyPhone",
  B2B_CONTACT_FIRST_NAME = "clientProfileB2BContactFirstName",
  B2B_CONTACT_LAST_NAME = "clientProfileB2BContactLastName",
  B2B_CONTACT_EMAIL = "clientProfileB2BContactEmail",
  B2B_CONTACT_PHONE = "clientProfileB2BContactPhone",
}

export enum ACCOUNT_BALANCE {
  ACCOUNT_BALANCE_WRAPPER = "clientProfileAccountBalanceWrapper",
  ACCOUNT_BALANCE_HEADING = "clientProfileAccountBalanceHeading",
  ACCOUNT_BALANCE_AMOUNT = "clientProfileAccountBalanceAmount",
  ACCOUNT_BALANCE_CURRENCY = "clientProfileAccountBalanceCurr",
  DURATION_BALANCE_WRAPPER = "clientProfileAccountDurationBalanceWrapper",
  DURATION_BALANCE_HEADING = "clientProfileAccountDurationBalanceHeading",
  DURATION_BALANCE_LABEL = "clientProfileAccountDurationBalanceLabel",
  DURATION_BALANCE_SUB_LABEL = "clientProfileAccountDurationBalanceSubLabel",
  DURATION_BALANCE_AMOUNT = "clientProfileAccountDurationBalanceAmount",
  PAYMENT_METHOD = "clientProfilePaymentMethod",
  MANAGE_PAYMENT_METHODS = "clientProfileAccountBalanceManagePaymentMethods",
  ADD_VOUCHER = "clientProfileAccountBalanceAddVoucher",
  MANAGE_PAYMENT_MODAL = "clientProfileAccountBalanceManagePaymentModal",
  ADD_PAYMENT_METHOD = "clientProfileAccountBalanceAddPaymentMethod",
  ADD_VOUCHER_MODAL = "clientProfileAccountBalanceAddVoucherModal",
  ENTER_VOUCHER_CODE_INPUT = "clientProfileAccountBalanceEnterVoucherCodeInput",
}

export enum PROFILE_BUTTONS {
  // general
  EDIT_INFO = "clientProfileEditInfoBtn",
  SAVE = "clientProfileSaveBtn",
  CANCEL = "clientProfileCancelBtn",
  CHANGE_PASSWORD = "clientProfileChangePasswordBtn",
  CONTACT_US = "clientProfileContactUsBtn",
  BOOK_A_NEW_CLEANING = "clientProfileBookCleaningBtn",

  // payment methods
  ADD_NEW_CREDIT_CARD = "clientProfileAddCreditCardBtn",
  CREDIT_CARD_EDIT = "clientProfileEditCreditCardBtn",
  CREDIT_CARD_DELETE = "clientProfileCreditCardDelete",
  CREDIT_CARD_SET_DEFAULT = "clientProfileCreditCardSetDefault",
}

export enum PAYMENT_METHODS {
  // labels
  DEFAULT_PAYMENT_METHOD_LABEL = "clientProfileDefaultPaymentMethodLabel",
  DEFAULT_PAYMENT_MODAL_METHOD_LABEL = "clientProfileModalDefaultPaymentMethodLabel",
  OTHER_PAYMENT_METHODS_LABEL = "clientProfileOtherPaymentMethodsLabel",
  NO_PAYMENT_METHODS = "clientProfileNoPaymentMethodsLabel",
  CARD_NUMBER = "clientProfileCardNumber",
  EXPIRY_DATE = "clientProfileExpiryDate",

  // elements
  DEFAULT_PAYMENT_LIST = "clientProfileDefaultPaymentMethodList",
  OTHER_PAYMENT_LIST = "clientProfileOtherPaymentMethodList",
  DEFAULT_PAYMENT_METHOD = "clientProfileDefaultPaymentMethod",
  DEFAULT_PAYMENT_MODAL_METHOD = "clientProfileModalDefaultPaymentMethod",
  OTHER_PAYMENT_METHOD = "clientProfileOtherPaymentMethod",
}

export enum LOCATIONS {
  SECTION = "clientProfileLocationsSection",
  LOCATIONS_LIST = "clientProfileLocationsList",
  ROW = "clientProfileLocationRow",
  ADDRESS = "clientProfileLocationAddress",
  ZIP_CODE = "clientProfileLocationZipCode",
  CITY = "clientProfileLocationCity",
  DROPDOWN = "clientProfileLocationDropdown",
  MORE_BUTTON = "clientProfileLocationMoreButton",
  SET_AS_DEFAULT = "clientProfileLocationSetAsDefaultButton",
  REMOVE = "clientProfileLocationRemoveButton",
  COUNTRY = "clientProfileLocationCountry",
  DEFAULT = "clientProfileDefaultAddress",
  CONTACT_US = "clientProfileLocationContactUs",
}

export enum UPCOMING_CLEANING {
  UPCOMING_CLEANING_WRAPPER = "clientProfileUpcomingCleaningWrapper",
  NO_UPCOMING_CLEANINGS = "clientProfileNoUpcomingCleanings",
  CLEANING_TYPE = "clientProfileUpcomingCleaningType",
  BEDROOMS = "clientProfileUpcomingCleaningBedrooms",
  BATHROOMS = "clientProfileUpcomingCleaningBathrooms",
  DURATION = "clientProfileUpcomingCleaningDuration",
  FREQUENCY = "clientProfileUpcomingCleaningFrequency",
  EOT_WARRANTY = "clientProfileUpcomingCleaningWarranty",
  DATE = "clientProfileUpcomingCleaningExecutionDate",
}

export enum UPCOMING_CLEANING_EXTRAS {
  INTERIOR_WINDOWS = "upcomingCleaningWindowsExtra",
  IRONING = "upcomingCleaningIroningExtra",
  LAUNDRY_WASH_AND_DRY = "upcomingCleaningLaundryWashExtra",
  INSIDE_OVEN = "upcomingCleaningOvenExtra",
  INSIDE_CABINETS = "upcomingCleaningCabinetsExtra",
  INSIDE_FRIDGE = "upcomingCleaningFridgeExtra",
  BONUS_15 = "upcomingCleaningBonus15MinutesExtra",
  DOOR_HANDLES = "upcomingCleaningDoorHandlesExtra",
  BASEBOARDS = "upcomingCleaningBaseboardsExtra",
  WINDOW_BLINDS = "upcomingCleaningWindowBlindsExtra",
  BALCONY = "upcomingCleaningBalconyExtra",
}
